export const initialState = {
  mediaItems: [],
  videoItems: [],
  audioItems: [],
  textRanges: [],
  jsonItems: [],
  bookmarkPos: -1,
  status: 'pending',
};
